// uses ./AppsListItemSuggestion.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { openSuggestion } from '../../appSuggestion/appSuggestionActionCreators';
import newIntegrationIdeaIcon from './new-integration-idea.png';

function AppsListItemSuggestion(props) {
    if (props.disableUploadingApp || !props.userExists) {
        return null;
    }

    return (
        <div className="appsListItemSuggestion">
            <img src={newIntegrationIdeaIcon} />
            <p className="appsListItemSuggestion-text">Can&apos;t see the integration you were looking for?</p>
            <button type="button" className="sg-button-primary" onClick={props.dispatchOpenSuggestion}>
                Let us know
            </button>
        </div>
    );
}

AppsListItemSuggestion.propTypes = {
    userExists: PropTypes.bool.isRequired,
    dispatchOpenSuggestion: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchOpenSuggestion: openSuggestion,
};

export default connect(
    (state) => ({ userExists: state.user.exists, disableUploadingApp: state.user.disableUploadingApp }),
    mapDispatchToProps
)(AppsListItemSuggestion);
